<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_product_quotation"
        :columns="columns"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        :url="url"
        :show-column-visible="true"
        :search-form-fields="formFields"
        @on-add="showFormModalDialog"
      />
    </div>
    <ProductQuotationDialog
      :id="entityId"
      :pid="productId"
      :visible="modalForm"
      :width="550"
      :action="url"
      @on-close="onModalClose"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import ProductQuotationDialog from './dialog/productQuotationDialog'
export default {
  name: 'ProductQuotationList',
  components: {
    TableWrapper, ProductQuotationDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    productId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      types: this.loadVehicleTypes(),
      loadingStatus: false,
      modalForm: false,
      submit: false,
      url: this.$config.apiContextPath + '/quotation',
      modCount: 0,
      entityId: 0,
      garages: this.loadGarages(),
      products: this.loadProducts()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '绑定车库', placeholder: '请选择绑定车库...', name: 'parkingId', width: '140px', type: 'select', options: this.garages, onChange: this.loadVehicleTypes },
          { label: '产品类别', placeholder: '请选择产品类别...', name: 'productId', width: '140px', type: 'select', options: this.products },
          { label: '车辆类别', placeholder: '请选择车辆类别...', name: 'vehicleType', width: '140px', type: 'select', hidden: false, options: this.types },
          { label: '产品名称', placeholder: '请输入产品名...', name: 'name', width: '140px', type: 'input' },
          { label: '产品类型', placeholder: '请选择产品类型', name: 'itemType', width: '140px', type: 'select', hidden: false, options: [
            { label: '包月', value: 0 },
            { label: '临停', value: 1 }]
          },
          { label: '产品状态', placeholder: '请选择产品状态', name: 'visible', width: '140px', type: 'select', hidden: false, options: [
            { label: '启用', value: 1 },
            { label: '停用', value: 0 }]
          }
        ]
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '绑定车库', align: 'left', key: 'parkingName', sortable: true, width: 160, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parkingName || '---')
          }
        },
        { title: '类型', align: 'center', key: 'itemType', sortable: true, width: 110,
          render: (h, params) => { return h('span', {}, params.row.itemType === 0 ? '包月' : '临停') }
        },
        { title: '产品类别', key: 'productName', align: 'center', width: 150, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.productName || '---')
          }
        },
        { title: '产品名称', align: 'left', key: 'name', sortable: true },
        { title: '车辆类型', align: 'center', key: 'vehicleTypeName', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.vehicleTypeName || '---')
          }
        },
        { title: '产品报价', align: 'center', key: 'price', sortable: true, width: 110, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.price + ' 元')
          }
        },
        // { title: '月份数', key: 'month', align: 'center', sortable: true },
        { title: '备注', align: 'left', key: 'remarks', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.remarks || '---')
          }
        },
        { title: '创建时间', align: 'center', key: 'createTime', sortable: true, width: 160, ellipsis: true, tooltip: true },
        // { title: '更新时间', align: 'center', key: 'updateTime', sortable: true, width: 160,
        //   render: (h, params) => {
        //     return h('span', {}, params.row.updateTime || '---')
        //   }
        // },
        { title: '状态', align: 'center', key: 'visible', sortable: true, width: 100, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.visible === 1 ? 'green' : 'red' }
            }, params.row.visible === 1 ? '启用' : '停用')
          }
        },
        { title: '操作', align: 'center', width: 145, key: '_actions', disabled: true,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.url = this.action
      }
    }
  },
  methods: {
    async loadVehicleTypes(parkingId) {
      const host = this.$config.apiContextPath + '/vehicle/type?fetchAll=true' + (parkingId ? '&parkingId=' + parkingId : '')
      await request({
        url: host,
        method: 'get'
      }).then(res => {
        this.types = []
        const items = res.data.content
        items.forEach(i => {
          this.types.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.types = []
      })
    },
    async loadProducts() {
      await request({
        url: this.$config.apiContextPath + '/product',
        method: 'get'
      }).then(res => {
        this.products = []
        const items = res.data.content
        items.forEach(i => {
          this.products.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.products = []
      })
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除`' + name + '`子产品么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '子产品 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '子产品 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.modalForm = false
      this.$emit('on-close', changed)
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>

